import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../locales/keys';
import ErrorScreen from '../../common/errorScreen';

const NoOrderablePricingPlans = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <ErrorScreen
        error={t(LocaleKeys.payment.orders.noOrderablePricingPlanMessage)}
        mt={5}
        mb={5}
        variant="body1"
        hideBackdrop={true}
      />
    </Box>
  );
};

export default NoOrderablePricingPlans;
